export default {
  button: {
    '&:hover': {
      backgroundColor: ' #E3F2FD',
      color: '#2196F3'
    }
  }
};
